<template>

  <div class="Footer">
    <div class="foot">
      <div class="foot-top">
        <!-- logo -->
        <div class="foot-logo">
          <router-link
            to="/index"
            title="CEASIA"
          ></router-link>
        </div>
        <!-- 导航 -->
        <div class="foot-left-list">
          <ul>
            <li
              v-for="(val,index) in  FooterList"
              :key="index"
            >
              <a
                v-if="val.footertlink==='1'"
                :title=val.footertitle
                @click="link()"
              >
                {{val.footertitle}}
              </a>
              <router-link
                v-if="val.footertlink!='1'"
                :to=val.footertlink
                :title=val.footertitle
              >
                {{val.footertitle}}
              </router-link>
            </li>

          </ul>
        </div>

      </div>
      <div class="foot-bottom">
        <div class="copyright-text">
          © {{new Date().getFullYear()}} CE-ASIA HONG KONG LIMITED All Rights Reserved.
        </div>
        <!-- 外联 -->
        <div class="foot-left-icon clearfix">
          <a
            class="icon-botton facebook"
            href="https://www.facebook.com/CE-Asia-%E4%B8%AD%E9%9B%BB%E5%8D%9A%E4%BA%9E-101330664694926"
            target="_blank"
          ></a>
          <a
            class="icon-botton  twitter"
            href="https://twitter.com/CEAsiaHK"
            target="_blank"
          ></a>
          <a
            class="icon-botton instagram"
            href="https://www.instagram.com/ceasiazdby/"
            target="_blank"
          ></a>
          <a
            class="icon-botton Youtube"
            href="https://www.youtube.com/channel/UCtv0ayeuNj8pfEKmUkDB6DA"
            target="_blank"
          ></a>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'Footer',
  computed: {
    FooterList() {
      if (this.$t('Footer') !== 'Footer') {
        return this.$t('Footer')
      }
    },
  },
  methods: {
    link() {
      window.open('https://www.sonkwo.hk/privacy', '_blank')
    },
  },
}
</script>
<style scoped>
@import './style/footer.min.css';
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue